// extracted by mini-css-extract-plugin
export default {"container":"LoanConfigurations_container__m1zDR","header":"LoanConfigurations_header__ajI9+","title":"LoanConfigurations_title__5RHi9","search":"LoanConfigurations_search__CNPCy"};